
import { Component, Vue } from 'vue-property-decorator'
import { getQueryVariable, isIOS } from '../utils'
import { openScheme, toAppMarketEnjoy } from '../utils'
@Component
export default class extends Vue {
  showPop = false
  isSuccess = this.$route.query.isSuccess
  isWeiXin = navigator.userAgent.toLowerCase().includes('micromessenger') // 判断是否是微信浏览器

  async iosDownload() {
    //zzsk.app://com.zzsk.app
    try {
      await openScheme(`zzsk.app://com.zzsk.app`, 5000)
    } catch (error) {
      console.log('openScheme error', error)
      window.location.href = 'https://apps.apple.com/cn/app/id6762977878'
    }
  }
  async androidDownload() {
    try {
      await openScheme(`kigo.enjoy://com.kigo.enjoy`, 3000)
    } catch (error) {
      console.log('openScheme error', error)
      toAppMarketEnjoy('daili')
    }
  }

  handlDownload() {
    if (this.isWeiXin) {
      this.showPop = true
    } else {
      if (isIOS) {
        this.iosDownload()
      } else {
        this.androidDownload()
      }
    }
  }
  mounted() {
    console.log('isSuccess', this.$route.query.isSuccess)
  }
}
